export default data => {
  return {
    '@type': 'WebSite',
    name: data?.title,
    description: data?.description,
    inLanguage: 'English',
    url: data?.canonicalUrl,
    keywords: 'streaming apps, tv shows & movies, live tv, streaming services',
    thumbnailUrl: data?.image,
    image: data?.image,
  };
};
